import log from "loglevel";
import { apiCoreEndpoint } from "settings";
import * as t from "./types";
import { processServiceResponse } from "lib/request";

export const getLogstashPipelinesService = (
  request: t.GetLogstashPipelinesRequestType
) => {
  const GET_LOGSTASH_PIPELINES_API_ENDPOINT = `${apiCoreEndpoint}/logstash/pipeline`;
  log.info("Logstash Pipelines Service Request: ", request);
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_LOGSTASH_PIPELINES_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(
        response,
        GET_LOGSTASH_PIPELINES_API_ENDPOINT
      );
    })
    .then((json) => {
      return json;
    });
};

export const getLogstashPipelineStatsService = (
  request: t.GetLogstashPipelineStatsRequestType
) => {
  const GET_LOGSTASH_PIPELINE_STATS_API_ENDPOINT = `${apiCoreEndpoint}/logstash/pipeline/stats`;
  log.info("Logstash Pipeline Stats Service Request: ", request);
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_LOGSTASH_PIPELINE_STATS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(
        response,
        GET_LOGSTASH_PIPELINE_STATS_API_ENDPOINT
      );
    })
    .then((json) => {
      return json;
    });
};
